import { useState } from 'react'
import { Form } from 'react-final-form'
import { Spacer } from '@jisr-hr/design-system'
import classNames from 'classnames'
import I18n from 'translations/i18n'
import { TextInputField } from 'components/final-form'
import { required } from 'components/global/form/FormValidations'
import { labels } from 'utils/whitelabel'
import { Button } from '@jisr-hr/ds'
import { mixPanelAnalytics } from 'utils/mixpanel'

export type TSlugValue = { email: string }

type Props = {
  onSubmit: (v: TSlugValue, isOrgName: boolean) => void
  fetching: boolean
}

const SlugFrom = ({ onSubmit, fetching }: Props): JSX.Element => {
  const [isOrgName, setIsOrgName] = useState(false)
  return (
    <Form onSubmit={(vals: TSlugValue): void => onSubmit(vals, isOrgName)}>
      {({ handleSubmit, submitting, form }): JSX.Element => (
        <form
          onSubmit={handleSubmit}
          className="login-form"
        >
          {/* @ts-expect-error Need to migrate TextInputField.js to TypeScript */}
          <TextInputField
            testId="login-slug"
            name="email"
            type="text"
            label={I18n.t(isOrgName ? 'slug' : 'email')}
            validate={required}
            placeholder={I18n.t(isOrgName ? 'organization_name' : 'example@gmail.com')}
          />
          <Button
            label={I18n.t(
              isOrgName ? 'login_using_email_address' : 'login_using_organization_name',
            )}
            type="button"
            size="sm"
            variant="link"
            onClick={(): void => {
              mixPanelAnalytics({
                event_name: 'login_using_organization__email',
                properties: {
                  login_by: isOrgName ? 'organization_name' : 'email_address',
                },
              })
              form.reset()
              setIsOrgName(!isOrgName)
            }}
          />
          <Spacer height="10px" />
          <Button
            disabled={fetching || submitting}
            label={I18n.t('submit')}
            type="submit"
            className={classNames(
              'login-btn-full',
              labels.name === 'Maken' && 'maken-btn',
              labels.name === 'Ahad' && 'ahad-btn',
            )}
          />
        </form>
      )}
    </Form>
  )
}

export default SlugFrom
